export const HORMONE_BUTTON_PERMISSIONS = {
  'user-dashboard': {
    // Read-only view of the client's hormone trackers; open to everyone who
    // can open the client dashboard, like Nutrition / Activity / Notes.
    'view-hormonal-wellness-tab': { departments: [], roles: [] },
  },
};

/** Hormones feature access — registered in configs/featureAccess. */
export const hormoneAccess = {
  id: 'hormones',
  routes: {},
  buttons: HORMONE_BUTTON_PERMISSIONS,
};
